<script>
import { BDropdown, BButton, BCollapse, VBToggle } from "bootstrap-vue";
import Simplebar from "simplebar-vue";
import { IconChevronDown, IconFilter } from "@/components/icons/index";

export default {
  name: "AppFilterDropdown",

  components: {
    Simplebar,
    BDropdown,
    BButton,
    BCollapse,
    IconChevronDown,
    IconFilter,
  },

  data() {
    return {
      activePromoStatuses: [],
      showTarget: true,
      showRegion: true,
      showCity: false,
      showRole: true,
      showCompany: false,
      showFunction: true,
      showProductCategory: true,
      showProductSubCategory: false,
      showPromoStatus: true,
      showEgiftCategory: true,
      showRewardStatus: false,
      showPromo: false,
      showServiceType: true,
      showStoreType: true,
      showCdssStatus: true,
    };
  },

  directives: {
    "b-toggle": VBToggle,
  },

  props: {
    // Email Notifications
    targets: { type: Array, default: () => [] },
    activeTargets: { type: Array, default: () => [] },
    // Customers
    regions: { type: Array, default: () => [] },
    activeRegions: { type: Array, default: () => [] },
    cities: { type: Array, default: () => [] },
    activeCities: { type: Array, default: () => [] },
    //
    roles: { type: Array, default: () => [] },
    activeRoles: { type: Array, default: () => [] },
    egifts: { type: Array, default: () => [] },
    companies: { type: Array, default: () => [] },
    activeCompanies: { type: Array, default: () => [] },
    functions: { type: Array, default: () => [] },
    activeFunctions: { type: Array, default: () => [] },
    // Canon Products, PIN Codes
    productCategories: { type: Array, default: () => [] },
    activeProductCategories: { type: Array, default: () => [] },
    // Canon Products
    productSubCategories: { type: Array, default: () => [] },
    activeProductSubCategories: { type: Array, default: () => [] },
    //
    egiftCategories: { type: Array, default: () => [] },
    activeEgiftCategories: { type: Array, default: () => [] },
    rewardStatuses: { type: Array, default: () => [] },
    activeRewardStatuses: { type: Array, default: () => [] },
    promoStatuses: { type: Array, default: () => [] },
    hideSubCategories: { type: Boolean, default: false },
    promos: { type: Array, default: () => [] },
    activePromos: { type: Array, default: () => [] },
    // Service Centers
    serviceTypes: { type: Array, default: () => [] },
    activeServiceTypes: { type: Array, default: () => [] },
    //
    storeTypes: { type: Array, default: () => [] },
    activeStoreTypes: { type: Array, default: () => [] },
    cdssStatuses: { type: Array, default: () => [] },
    activeCdss: { type: Array, default: () => [] },
  },

  methods: {
    toggleTarget(target) {
      const { activeTargets } = this;
      const index = activeTargets.findIndex((item) => item == target);
      if (index >= 0) {
        activeTargets.splice(index, 1);
      } else {
        activeTargets.push(target);
      }
      this.$emit("targetChange", activeTargets);
    },
    toggleRegion(region) {
      const { activeRegions } = this;
      const index = activeRegions.findIndex((item) => item == region);
      if (index >= 0) {
        activeRegions.splice(index, 1);
      } else {
        activeRegions.push(region);
      }
      this.$emit("regionChange", activeRegions);
    },
    toggleCity(city) {
      const { activeCities } = this;
      const index = activeCities.findIndex((item) => item == city);
      if (index >= 0) {
        activeCities.splice(index, 1);
      } else {
        activeCities.push(city);
      }
      this.$emit("cityChange", activeCities);
    },
    toggleRole(role) {
      const { activeRoles } = this;
      const index = activeRoles.findIndex((item) => item == role);
      if (index >= 0) {
        activeRoles.splice(index, 1);
      } else {
        activeRoles.push(role);
      }
      this.$emit("roleChange", activeRoles);
    },
    toggleCompany(company) {
      const { activeCompanies } = this;
      const index = activeCompanies.findIndex((item) => item == company);
      if (index >= 0) {
        activeCompanies.splice(index, 1);
      } else {
        activeCompanies.push(company);
      }
      this.$emit("companyChange", activeCompanies);
    },
    toggleFunctions(func) {
      const { activeFunctions } = this;
      const index = activeFunctions.findIndex((item) => item == func);
      if (index >= 0) {
        activeFunctions.splice(index, 1);
      } else {
        activeFunctions.push(func);
      }
      this.$emit("functionChange", activeFunctions);
    },
    toggleProductCategory(categoryId) {
      const { activeProductCategories } = this;
      const index = activeProductCategories.findIndex((item) => item == categoryId);
      if (index >= 0) {
        activeProductCategories.splice(index, 1);
      } else {
        activeProductCategories.push(categoryId);
      }
      this.$emit("categoryChange", activeProductCategories);
    },
    toggleProductSubCategory(subCat) {
      const { activeProductSubCategories } = this;
      const index = activeProductSubCategories.findIndex((item) => item == subCat);
      if (index >= 0) {
        activeProductSubCategories.splice(index, 1);
      } else {
        activeProductSubCategories.push(subCat);
      }
      this.$emit("subCategoryChange", activeProductSubCategories);
    },
    togglePromoStatus(status) {
      const index = this.activePromoStatuses.findIndex((item) => item == status);
      if (index >= 0) {
        this.activePromoStatuses.splice(index, 1);
      } else {
        this.activePromoStatuses.push(status);
      }
      this.$emit("promoStatusChange", this.activePromoStatuses);
    },
    toggleEgiftCategory(egift) {
      const { activeEgiftCategories } = this;
      const index = activeEgiftCategories.findIndex((item) => item == egift);

      if (index >= 0) {
        activeEgiftCategories.splice(index, 1);
      } else {
        activeEgiftCategories.push(egift);
      }
      this.$emit("egiftCategoryChange", activeEgiftCategories);
    },
    toggleRewardStatus(rewardStatus) {
      const { activeRewardStatuses } = this;
      const index = activeRewardStatuses.findIndex((item) => item == rewardStatus);

      if (index >= 0) {
        activeRewardStatuses.splice(index, 1);
      } else {
        activeRewardStatuses.push(rewardStatus);
      }
      this.$emit("rewardStatusChange", activeRewardStatuses);
    },
    togglePromo(promo) {
      const { activePromos } = this;
      const index = activePromos.findIndex((item) => item == promo);
      if (index >= 0) {
        activePromos.splice(index, 1);
      } else {
        activePromos.push(promo);
      }
      this.$emit("promoChange", activePromos);
    },
    toggleServiceType(serviceTypeId) {
      const { activeServiceTypes } = this;
      const index = activeServiceTypes.findIndex((item) => item == serviceTypeId);
      if (index >= 0) {
        activeServiceTypes.splice(index, 1);
      } else {
        activeServiceTypes.push(serviceTypeId);
      }
      this.$emit("serviceTypeChange", activeServiceTypes);
    },
    toggleStoreType(storeTypeId) {
      const { activeStoreTypes } = this;
      const index = activeStoreTypes.findIndex((item) => item == storeTypeId);
      if (index >= 0) {
        activeStoreTypes.splice(index, 1);
      } else {
        activeStoreTypes.push(storeTypeId);
      }
      this.$emit("storeTypeChange", activeStoreTypes);
    },
    toggleCdssStatus(cdssStatus) {
      const { activeCdss } = this;
      const index = activeCdss.findIndex((item) => item == cdssStatus);
      if (index >= 0) {
        activeCdss.splice(index, 1);
      } else {
        activeCdss.push(cdssStatus);
      }
      this.$emit("cdssStatusChange", activeCdss);
    },
  },

  computed: {
    isAdmin() {
      return !!this.roles.length || !!this.companies.length;
    },
    isUser() {
      return !!this.regions.length || !!this.cities.length;
    },
    isCanonProduct() {
      return !!this.productCategories.length || !!this.productSubCategories.length;
    },
    isPromo() {
      return !!this.promoStatuses.length;
    },
    isRewards() {
      return !!this.egiftCategories.length || !!this.rewardStatuses.length;
    },
    isStoreTypes() {
      return !!this.storeTypes.length;
    },
    isProductRegistration() {
      return !!this.promos.length;
    },
    isWarranty() {
      return !!this.serviceTypes.length;
    },
    isProductRepair() {
      return !!this.cdssStatuses.length;
    },
  },
};
</script>

<template>
  <b-dropdown right variant="light" class="p-0 m-0 filter-dropdown">
    <template #button-content>
      <IconFilter />
      <span class="ms-2 fw-medium text-muted"> Filter</span>
    </template>

    <div
      class="filter-dropdown-content overflow-hidden"
      :style="{ width: '235px', borderRadius: '4px' }"
    >
      <!-- Target  -->
      <b-button
        v-if="targets.length"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showTarget }"
        @click="showTarget = !showTarget"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Target</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showTarget">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li v-for="(target, key) in targets" :key="key" @click="toggleTarget(target)">
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeTargets.includes(target)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ target }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>
      <!-- Region  -->
      <b-button
        v-if="isUser"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showRegion }"
        @click="showRegion = !showRegion"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Region</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showRegion">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li v-for="(region, key) in regions" :key="key" @click="toggleRegion(region)">
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeRegions.includes(region)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ region }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>
      <!-- City  -->
      <b-button
        v-if="isUser"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showCity }"
        @click="showCity = !showCity"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>City</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showCity">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li v-for="(city, key) in cities" :key="key" @click="toggleCity(city)">
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeCities.includes(city)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ city }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>
      <!-- Role  -->
      <b-button
        v-if="isAdmin"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showRole }"
        @click="showRole = !showRole"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Role</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showRole">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li v-for="(role, key) in roles" :key="key" @click="toggleRole(role)">
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeRoles.includes(role)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ role }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>
      <!-- Business Unit  -->
      <b-button
        v-if="isAdmin"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showCompany }"
        @click="showCompany = !showCompany"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Business Unit</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showCompany">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li
              v-for="(company, key) in companies"
              :key="key"
              @click="toggleCompany(company)"
            >
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeCompanies.includes(company)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ company }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>
      <!-- Function  -->
      <b-button
        v-if="functions.length"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showFunction }"
        @click="showFunction = !showFunction"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Function</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showFunction">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li
              v-for="(func, key) in functions"
              :key="key"
              @click="toggleFunctions(func)"
            >
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeFunctions.includes(func)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ func }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>

      <!-- Category  -->
      <b-button
        v-if="isCanonProduct"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showProductCategory }"
        @click="showProductCategory = !showProductCategory"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Category</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showProductCategory">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li
              v-for="(category, key) in productCategories"
              :key="key"
              @click="toggleProductCategory(category.id)"
            >
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeProductCategories.includes(category.id)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ category.name }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>
      <!-- Sub Category  -->
      <b-button
        v-if="isCanonProduct && !hideSubCategories"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showProductSubCategory }"
        @click="showProductSubCategory = !showProductSubCategory"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Sub Category</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showProductSubCategory">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li
              v-for="(product, key) in productSubCategories"
              :key="key"
              @click="toggleProductSubCategory(product.id)"
            >
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeProductSubCategories.includes(product.id)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ product.name }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>

      <!-- Promo Status  -->
      <b-button
        v-if="isPromo"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showPromoStatus }"
        @click="showPromoStatus = !showPromoStatus"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Status</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showPromoStatus">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li
              v-for="(status, key) in promoStatuses"
              :key="key"
              @click="togglePromoStatus(status)"
            >
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activePromoStatuses.includes(status)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ status }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>

      <!-- EGift  -->
      <b-button
        v-if="isRewards"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showEgiftCategory }"
        @click="showEgiftCategory = !showEgiftCategory"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>eGift Category</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showEgiftCategory">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li
              v-for="(category, key) in egiftCategories"
              :key="key"
              @click="toggleEgiftCategory(category)"
            >
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeEgiftCategories.includes(category)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ category }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>

      <!-- EGift  -->
      <b-button
        v-if="isRewards"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showRewardStatus }"
        @click="showRewardStatus = !showRewardStatus"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Status</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showRewardStatus">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li
              v-for="(rewardStatus, key) in rewardStatuses"
              :key="key"
              @click="toggleRewardStatus(rewardStatus)"
            >
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeRewardStatuses.includes(rewardStatus)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ rewardStatus }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>

      <!-- Promo Status  -->
      <b-button
        v-if="isProductRegistration"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showPromo }"
        @click="showPromo = !showPromo"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Promo</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showPromo">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li v-for="(promo, key) in promos" :key="key" @click="togglePromo(promo)">
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activePromos.includes(promo)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ promo }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>

      <!-- Service Type  -->
      <b-button
        v-if="isWarranty"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showServiceType }"
        @click="showServiceType = !showServiceType"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Service Type</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showServiceType">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li
              v-for="(serviceType, key) in serviceTypes"
              :key="key"
              @click="toggleServiceType(serviceType.id)"
            >
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeServiceTypes.includes(serviceType.id)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ serviceType.name }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>

      <!-- Store Type  -->
      <b-button
        v-if="isStoreTypes"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showStoreType }"
        @click="showStoreType = !showStoreType"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>Store Type</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showStoreType">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li
              v-for="(storeType, key) in storeTypes"
              :key="key"
              @click="toggleStoreType(storeType)"
            >
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeStoreTypes.includes(storeType)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ storeType }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>

      <!-- CDSS Status  -->
      <b-button
        v-if="isProductRepair"
        variant="light"
        class="d-block border-0 rounded-0 fw-medium filter-dropdown-trigger"
        :class="{ active: showCdssStatus }"
        @click="showCdssStatus = !showCdssStatus"
        :style="{ color: '#74788D' }"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>CDSS Status</span>
          <IconChevronDown size="12px" />
        </div>
      </b-button>
      <b-collapse v-model="showCdssStatus">
        <Simplebar data-simplebar :style="{ maxHeight: '183px' }">
          <ul class="filter-dropdown-list">
            <li
              v-for="(cdssStatus, key) in cdssStatuses"
              :key="key"
              @click="toggleCdssStatus(cdssStatus)"
            >
              <div class="form-check ps-0 w-100 d-flex justify-content-center">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="activeCdss.includes(cdssStatus)"
                />
                <label
                  class="form-check-label ms-2 w-100 d-block text-truncate"
                  for="formrow-customCheck"
                >
                  {{ cdssStatus }}
                </label>
              </div>
            </li>
          </ul>
        </Simplebar>
      </b-collapse>
    </div>
  </b-dropdown>
</template>

<style lang="scss">
.filter-dropdown {
  .dropdown-menu {
    padding: 0;
  }

  .dropdown-toggle {
    &.btn-light {
      &:hover {
        border: 1px solid #ced4da;
      }
    }
  }

  &-trigger {
    &.active {
      svg {
        transform: rotate(180deg);
        transition: transform 0.2s;
      }
    }
  }

  &-content {
    .btn {
      margin: 0;
      width: 100%;
      outline: none;
      background: white;
    }
    .card {
      margin: 0;
    }
    #collapse-a,
    #collapse-b {
      margin: 0 !important;
    }
  }

  &-list {
    background: #f9fbfc;

    li {
      height: 36px;
      color: #74788d;
      display: flex;
      align-items: center;
      padding: 0 10px;
    }
    .form-check-input {
      border-radius: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
.simplebar-content {
  background: #f9fbfc;
}

.custom-checkbox {
  .custom-control-input {
    border-radius: 0;
  }
}
</style>
